(() => {
  function init(scope=document) {
    scope.querySelectorAll('[data-carousel]').forEach(carousel=>{
      if(carousel.dataset.ready)return;carousel.dataset.ready='true';
      const track=carousel.querySelector('[data-carousel-track]');
      if(!track)return;
      const cards=[...track.children];const dots=[...carousel.querySelectorAll('[data-carousel-dot]')];
      const controls=carousel.querySelector('.cv-carousel-controls');
      let stops=[0],cardPositions=[],pending=null,scrollFrame=0;
      const index=()=>stops.reduce((best,left,i)=>Math.abs(left-track.scrollLeft)<Math.abs(stops[best]-track.scrollLeft)?i:best,0);
      const update=()=>{
        const active=index();
        dots.forEach((dot,i)=>{
          dot.hidden=stops.length<2||i>=stops.length;
          dot.setAttribute('aria-current',String(i===active&&!dot.hidden));
        });
        if(controls)controls.hidden=stops.length<2;
        if(pending!==null&&Math.abs(track.scrollLeft-stops[pending])<2)pending=null;
      };
      const measure=()=>{
        const max=Math.max(0,track.scrollWidth-track.clientWidth);
        const origin=track.getBoundingClientRect().left;
        cardPositions=cards.map(card=>Math.max(0,Math.min(max,card.getBoundingClientRect().left-origin+track.scrollLeft)));
        stops=[];
        cardPositions.forEach(left=>{
          if(max-left<2)left=max;
          if(!stops.length||Math.abs(left-stops[stops.length-1])>2)stops.push(left);
        });
        if(!stops.length)stops=[0];
        pending=null;
        update();
      };
      const go=page=>{
        pending=(page+stops.length)%stops.length;
        track.scrollTo({left:stops[pending],behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
        update();
      };
      carousel.querySelector('[data-carousel-prev]')?.addEventListener('click',()=>go((pending??index())-1));
      carousel.querySelector('[data-carousel-next]')?.addEventListener('click',()=>go((pending??index())+1));
      dots.forEach((dot,i)=>dot.addEventListener('click',()=>{if(!dot.hidden)go(i);}));
      track.addEventListener('scroll',()=>{
        if(scrollFrame)return;
        scrollFrame=requestAnimationFrame(()=>{scrollFrame=0;update();});
      },{passive:true});
      ['pointerdown','touchstart','wheel'].forEach(type=>track.addEventListener(type,()=>{pending=null;},{passive:true}));
      track.addEventListener('scrollend',()=>{pending=null;update();});
      carousel.addEventListener('shopify:block:select',event=>{
        const selected=cards.findIndex(card=>card.dataset.shopifyEditorBlock?.includes(event.detail.blockId));
        if(selected>=0)go(stops.reduce((best,left,i)=>Math.abs(left-cardPositions[selected])<Math.abs(stops[best]-cardPositions[selected])?i:best,0));
      });
      const resize=new ResizeObserver(measure);
      resize.observe(track);
      carousel.closest('.shopify-section')?.addEventListener('shopify:section:unload',()=>resize.disconnect(),{once:true});
      measure();
    });
    const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{const video=entry.target;if(!entry.isIntersecting){video.pause();return;}if(!video.dataset.loaded){const deferred=[...video.querySelectorAll('source[data-src]')];deferred.forEach(source=>{source.src=source.dataset.src;source.removeAttribute('data-src');});if(deferred.length)video.load();video.dataset.loaded='true';}if(video.hasAttribute('data-autoplay')&&!matchMedia('(prefers-reduced-motion: reduce)').matches)video.play().catch(()=>{});}),{rootMargin:'50px'});
    scope.querySelectorAll('.cv-lazy-video').forEach(v=>observer.observe(v));
  }
  init();document.addEventListener('shopify:section:load',event=>init(event.target));
})();
